export const MAX_RETRIES = 3
export const RETRY_DELAY = 2000 // 2 seconds
